module.exports = __webpack_public_path__ + "cf8cb3d750d8f07a35f8cfaf49d2e8b0.pdf";